import { OnInit, AfterViewInit, Component } from '@angular/core'
import { Subscription, interval } from 'rxjs';
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { AtomModule } from '../../atom/atom.module'
import { ActivatedRoute, Router } from '@angular/router'
import { CartService } from '../../service/cart.service';
import { switchMap, takeWhile, catchError } from 'rxjs/operators';

@Component({
  selector: 'app-payment-complete',
  templateUrl: './payment-complete.component.html',
  styleUrl: './payment-complete.component.less',
  standalone: true,
  imports: [
    AtomModule
  ],
})
export class PaymentCompleteComponent implements OnInit {
  
  private pollSubscription: Subscription;
  orderCode: string;
  loadingState = true;
  errorState = false;
  timeoutId;
  
  constructor(
    private notificationService: NzNotificationService,
    private router: Router,
    private route: ActivatedRoute,
    private cartService: CartService,
  ) {}
  
  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const orderId = params['order_id']
      this.checkOrderState(orderId)
    })
    
    this.timeoutId = setTimeout(() => {
      if (this.loadingState) {
        this.handleLongWaitingTime();
      }
    }, 15000)
  }
  
  checkOrderState(orderId: string) { 
    this.pollSubscription = interval(1000).pipe(
      switchMap(() => this.cartService.fetchOrderById(orderId)), // Fetch order status every 1 second
      takeWhile(response => {
        const order = response?.data?.order;
        return order?.state !== 'PaymentSettled'; // Continue polling until the state is 'PaymentSettled'
      }, true), // Emit the last value even when the condition fails (when the state is 'PaymentSettled')
      catchError(err => {
        this.notificationService.error('Order Not Found', 'We couldn’t find your order. Please check the link or try again.');
        throw err; // Rethrow error for handling downstream if needed
      })
    ).subscribe({
      next: (response) => {
        console.log(response)
        const order = response?.data?.order;
        
        if (!order) {
          this.notificationService.error('Order Not Found', 'We couldn’t find your order. Please check the link or try again.');
          this.router.navigate(['/']).then(() => {
            if (this.timeoutId) {
              console.log(`Cancel payment completed timeout`)
              clearTimeout(this.timeoutId); // Cancel the timeout
            }
          })
          return
        }
        
        this.orderCode = `#${order?.code}`
        
        if (order?.state === 'PaymentSettled') {
          this.loadingState = false;
          this.notificationService.success('Payment Successful', 'Your payment has been processed successfully.')
          this.pollSubscription.unsubscribe();
        }
      },
      error: (err)=> {
        console.error(err)
        this.router.navigate(['/']).then(() => {
          if (this.timeoutId) {
            console.log(`Cancel payment completed timeout`)
            clearTimeout(this.timeoutId); // Cancel the timeout
          }
        })
      }
    })
  }
  
  handleLongWaitingTime() {
    this.pollSubscription.unsubscribe();
    this.errorState = true;
    this.notificationService.error('Payment Timeout', 'The payment is taking too long to process. Please try again.');
  }
}